var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMiconProgressBarRound = function SvgMiconProgressBarRound(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentcolor",
    d: "M16 22a6 6 0 1 1 6-6 6.007 6.007 0 0 1-6 6m0-10a4 4 0 1 0 0 8 4 4 0 0 0 0-8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentcolor",
    d: "M16 26a10.02 10.02 0 0 1-7.453-3.332l1.49-1.334A7.999 7.999 0 1 0 16 8V6a10 10 0 0 1 0 20"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "currentcolor",
    d: "M16 30a14 14 0 1 1 14-14 14.016 14.016 0 0 1-14 14m0-26a12 12 0 1 0 12 12A12.014 12.014 0 0 0 16 4"
  })));
};
export default SvgMiconProgressBarRound;